import { render, staticRenderFns } from "./SradioEditor.vue?vue&type=template&id=054e9b05&"
import script from "./SradioEditor.vue?vue&type=script&lang=js&"
export * from "./SradioEditor.vue?vue&type=script&lang=js&"
import style0 from "./SradioEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports